<template>
  <div class="open-time">
    <h1 class="m-font-1 ml-36">讲解服务</h1>
    <div class="open-content">
      <div class="mb-70">
        <div class="m-font-5 pf-regular mb-50">免费定时讲解服务</div>
        <div class="week m-font-2 pf-light mb-30">辽宁省博物馆提供免费定时讲解服务，由博物馆专业讲解员为观众详细介绍展览。</div>
        <div class="week m-font-2 pf-light mb-10">服务时间：上午 10:00 下午 14:00。</div>
      </div>
      <div>
        <div class="m-font-5 pf-regular mb-50">志愿者免费讲解服务时间表</div>
        <el-table :data="dataList" stripe border style="width: 100%">
          <el-table-column prop="exhibitionName" show-overflow-tooltip label="展览名称">
          </el-table-column>
          <el-table-column prop="appointment_time" show-overflow-tooltip label="讲解时间">
          </el-table-column>
          <el-table-column prop="name" show-overflow-tooltip label="讲解人">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      dataList: []
    };
  },

  mounted() {
    this.getExplanationTimetable()

    // 开发环境不循环 便于查看控制台
    if (process.env.VUE_APP_START_INTERVAL == '1') {
      if (window.InitSetInterval2) {
        clearInterval(window.InitSetInterval2)
      }
      window.InitSetInterval2 = setInterval(() => {
        console.log('refresh')
        this.getExplanationTimetable()
      }, 1000 * 5) // 5秒
    }
  },
  beforeDestroy() {
    if (window.InitSetInterval2) {
      clearInterval(window.InitSetInterval2)
    }
  },

  methods: {
    getExplanationTimetable() {
      this.$http.get('../singleMuseum/applet/volunteer/explanationTimetable', {
        date: this.$common.formatDateString(new Date(), 'yyyy-MM-dd')
      }).then(res => {
        if (res.success) {
          this.dataList = res.result
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;
  h1 {
    margin-bottom: 50px;
    // font-size: 44px;
    font-weight: 400;
    color: #000000;
  }

  .open-content {
    margin: 0 36px;
    .date {
      font-size: 22px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 20px;
    }

    .week,
    .close {
      color: #010101;
      font-weight: 400;
    }

    /deep/.el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 15px 0;
        }
      }

      .el-table__body-wrapper {
        .el-table__empty-text {
          font-family: pf-light;
          color: #010101;
          font-weight: 400;
          font-size: 28px;
        }
      }
      .cell {
        font-family: pf-light;
        color: #010101;
        font-weight: 400;
        height: 60px;
        line-height: 60px;
        font-size: 28px;
      }
    }
  }
}
</style>